/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
   LOAD_RECORDS_VALID_CACHE,
  LOAD_ATTENDENCE_SUCCESS,
  LOAD_ATTENDENCE_ERROR,
  LOAD_CHECKINOUT_SUCCESS,
  LOAD_CHECKINOUT_ERROR,
  LOAD_MONTHLY_RECORD_SUCCESS,
  LOAD_MONTHLY_RECORD_ERROR
} from "./constants";

const initialState = {
  monthly_list: {},
  attendence_list:[],
  checkinOut_list:[],
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    attendence_list,
    checkinOut_list,
    monthly_list,
    error,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
     
      case LOAD_ATTENDENCE_SUCCESS:
        draft.attendence_list = attendence_list;
        draft.error = false;
        draft.success = false;
        break;
        case LOAD_CHECKINOUT_SUCCESS:
          draft.checkinOut_list = checkinOut_list;
          draft.error = false;
          draft.success = false;
          break;
            case LOAD_MONTHLY_RECORD_SUCCESS:
          draft.monthly_list = monthly_list;
          draft.error = false;
          draft.success = false;
          break;
      case LOAD_MONTHLY_RECORD_ERROR:
      case LOAD_CHECKINOUT_ERROR:
      case LOAD_ATTENDENCE_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
